'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-8 lg:px-20 bg-[#1B5E4F]">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-4 md:mb-6">
          <Icon name="EnvelopeIcon" size={40} className="mx-auto text-white/80 md:hidden" />
          <Icon name="EnvelopeIcon" size={48} className="mx-auto text-white/80 hidden md:block" />
        </div>

        <h2 className="font-headline text-3xl md:text-4xl lg:text-5xl font-normal text-white tracking-tight leading-tight mb-4">
          Stay Inspired
        </h2>

        <p className="text-base md:text-lg text-white/90 font-normal mb-6 md:mb-8 max-w-2xl mx-auto">
          Subscribe to our newsletter for weekly design insights, cultural heritage stories, and exclusive tips for creating beautiful Indian homes.
        </p>

        {isSubmitted ? (
          <div className="bg-white/10 border border-white/20 text-white px-6 py-4 rounded-2xl inline-flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} />
            <span className="font-medium">
              Thank you for subscribing! Check your inbox for confirmation.
            </span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 px-4 py-3 bg-white text-black rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white/50 transition-all duration-200"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-black text-white font-medium rounded-full hover:bg-black/80 transition-all duration-200 whitespace-nowrap"
              >
                Subscribe
              </button>
            </div>
            <p className="text-xs text-white/70 mt-3">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </form>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;